/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */


var Model = require("../types/Model.js");
var BLE = require("bleh");
var xtend = require("xtend");

module.exports = new Model({
	name: "bluetooth",
	init: init,
	uninit: uninit,
	triggers: triggers,

	_ble: null,
	dispatchDestroyed: dispatchDestroyed,
});

function init() {
	this.push({
		scanning: false,
		initialized: false
	});
}

function uninit() {
	if (this.data.initialized) {
		this._ble.destroy();
	}
}

function triggers() {
	return {
		"bluetooth:off": turn_off,
		"bluetooth:on": turn_on,
		"connect": connect,
		"destroy": destroy,
		"disconnect": disconnect,
		"initialize": initialize,
		"listen:stop": unlisten,
		"listen": listen,
		"poll:stop": unpoll,
		"poll": poll,
		"read": read,
		"scan:stop": stopScan,
		"scan": scan,
		"write": write,
	};
}

function initialize() {
	if (this.data.initialized) return;
	var ble = BLE();
	this._ble = ble;

	ble.events.map(makeEmitter(this, "event"));
	ble.errors.map(makeEmitter(this, "error"));
	ble.disconnected.map(makeEmitter(this, "disconnected"));
	ble.scanned.map(makeEmitter(this, "scanned"));
	ble.scanning.map(makeEmitter(this, "scanning"));
	ble.loaded.map(makeEmitter(this, "loaded"));
	ble.scanning.map(handle_scanning.bind(this));

	this.extend({
		initialized: true
	});
}

function makeEmitter(model, event) {
	return function (data) {
		model.dispatch(event, data);
		// model.emit(`$mqtt:$/bluetooth/${event}`, decycle(data));
	};
}

function scan() {
	if (!this.data.initialized) return;
	this._ble.scan();
}

function stopScan() {
	if (!this.data.initialized) return;
	this._ble.stopScan();
}

function connect(data) {
	if (!this.data.initialized) return;
	var mac = data?.mac;
	var model = data?.model;
	// this.emit("$mqtt:$/bluetooth/connect", data);
	this._ble?.connect(mac)
		.then(handle_connected.bind(this, model))
		.catch(makeEmitter(this, "failed"));
	this.emit("usermetrics:trigger:track", "connect bluetooth device");
}

function handle_connected(model, data){
	var emitData = xtend(data, {
		model: model
	});
	this.dispatch("connected", emitData);
	// this.emit("$mqtt:$/bluetooth/connected", {
	// 	id: data.id,
	// 	name: data.name,
	// 	model: model
	// });
}

function disconnect(data) {
	if (!this.data.initialized) return;
	var mac = data.mac;
	// this.emit("$mqtt:$/bluetooth/disconnect", data);
	this._ble.disconnect(mac);
	this.emit("usermetrics:trigger:track", "disconnect bluetooth device");
}

function write(data) {
	if (!this.data.initialized) return;
	// this.emit("$mqtt:$/bluetooth/write", data);
	this._ble.write(
		data.service,
		data.characteristic,
		data.value,
		data.device
	).then(handle_written.bind(this, data.service, data.characteristic, data.device));
}

function handle_written(service, characteristic, device, value){
	var data = {
		service: service,
		characteristic: characteristic,
		value: value,
		device: device
	};
	// this.emit("$mqtt:$/bluetooth/written", decycle(data));
	this.dispatch("written", data);
}

function read(data) {
	if (!this.data.initialized) return;
	// this.emit("$mqtt:$/bluetooth/read", data);
	this._ble.read(
		data.service,
		data.characteristic,
		data.device
	)
		.then(handle_read.bind(this))
		.catch(makeEmitter(this, "error"));

	function handle_read(buffer) {
		var eventData = {
			characteristic: data.characteristic,
			device: data.device,
			data: new Uint8Array(buffer)
		};
		this.dispatch("event", eventData);
		// this.emit("$mqtt:$/bluetooth/event", eventData);
	}
}

function poll(data) {
	if (!this.data.initialized) return;
	// this.emit("$mqtt:$/bluetooth/poll", data);
	this._ble.poll(
		data.time,
		data.service,
		data.characteristic,
		data.device
	);
}

function unpoll(data) {
	if (!this.data.initialized) return;
	// this.emit("$mqtt:$/bluetooth/unpoll", data);
	this._ble.unpoll(
		data.service,
		data.characteristic,
		data.device
	);
}

function listen(data) {
	if (!this.data.initialized) return;
	// this.emit("$mqtt:$/bluetooth/listen", data);
	this._ble.listen(
		data.service,
		data.characteristic,
		data.device
	);
}

function unlisten(data) {
	if (!this.data.initialized) return;
	// this.emit("$mqtt:$/bluetooth/unlisten", data);
	this._ble.unlisten(
		data.service,
		data.characteristic,
		data.device
	);
	this.emit("usermetrics:trigger:track", "stop listening to bluetooth device");
}

function handle_scanning(scanning) {
	this.extend({
		scanning: scanning
	});
}

function turn_on() {
	if (!this.data.initialized) return;
	this._ble.enable();
	this.emit("usermetrics:trigger:track", "turn on bluetooth");
}

function turn_off() {
	if (!this.data.initialized) return;
	this._ble.disable();
	this.emit("usermetrics:trigger:track", "turn off bluetooth");
}

function destroy() {
	if(!this.data.initialized) return this.dispatchDestroyed();
	this._ble.destroy()?.then(dispatchDestroyed.bind(this));
}

function dispatchDestroyed() {
	this.dispatch("destroyed");
}